module.exports = __webpack_public_path__ + "static/img/team2-02.432b8c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team2-02.jpg
// module id = 58Zl
// module chunks = 1